import React from 'react';
import { Navbar } from './Navbar';
import { cn } from '../utils/cn';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="h-[100dvh] flex flex-col bg-bg-base overflow-hidden">
      <main
        className={cn(
          "flex-1 relative mx-auto w-full max-w-md pb-20",
          "overflow-hidden flex flex-col"
        )}
      >
        {children}
      </main>

      <Navbar />
    </div>
  );
};
